import * as React from 'react';
import { ActivityBannerType } from '../../../common/__generated__/api';
import { useStores } from '../../../utils/hooks';
import { getBannerByType } from '.';

export interface ShopWithPointsBannerProps {
  isDestinationView?: boolean;
}

export const ShopWithPointsBanner: React.FC<ShopWithPointsBannerProps> = ({
  isDestinationView
}): JSX.Element | null => {
  const { activitySearchStore, analytics, routeStore } = useStores();
  const banners = getBannerByType(activitySearchStore, ActivityBannerType.SHOP_WITH_POINTS);

  if (!banners || banners.length <= 0) {
    return null;
  }

  const togglePointsApplied = (): void => {
    const isShopWithPointsApplied = routeStore.queryParams.swp !== 'off';
    const newQueryString = routeStore.mergeQueryString(routeStore.search, {
      swp: isShopWithPointsApplied ? 'off' : 'on'
    });
    const rfrrPrefix = isDestinationView ? 'LX.Des.' : 'LX.SR.';
    const rfrrId = isShopWithPointsApplied ? `${rfrrPrefix}RemovePoints` : `${rfrrPrefix}ApplyPoints`;

    analytics.trackEvent(rfrrId, 'loyalty-points-toggle-clicked', analytics.omnitureData);
    routeStore.updateSearch(newQueryString, {}, true);
  };

  return (
    <aside className="uitk-type-paragraph-200 uitk-type-bold" data-testid="shop-with-points-banner">
      {banners[0].title && <span>{banners[0].title}</span>}
      {banners[0].subtitle && (
        <button className="uitk-button-old-link all-l-margin-one" onClick={togglePointsApplied}>
          {banners[0].subtitle}
        </button>
      )}
    </aside>
  );
};
